import { SelectableRow } from '@os-components';
import { SparePart, SparePartGroup, SparePartGroupList, SpareParts } from './spare-parts.interface';

export const isSparePartGroupList = (obj: any): obj is SparePartGroupList => Array.isArray(obj.groups);
export const isSelectableSparePartRowArray = (arr: any[]): arr is SelectableRow<SparePart>[] =>
    arr.every(
        (obj) =>
            typeof obj === 'object' &&
            isSparePart(obj.rowData) &&
            'isSelectableRow' in obj &&
            'isDisabled' in obj
    );
export const isSparePart = (obj: any): obj is SparePart =>
    typeof obj === 'object' && 'id' in obj && 'name' in obj && 'favorite' in obj && 'availabilityCode' in obj;

/**
 * Type guard for SparePartGroup, ensuring that the `driveGroup` and the `spareParts` are defined.
 *
 * @param group `sparePartGroup`
 * @returns wheter the `sparePartGroup` has defined properties `driveGroup` and `spareParts`
 */
export const isGroupWithDriveGroupAndSpareParts = (
    group: SparePartGroup
): group is SparePartGroup & { driveGroup: string; spareParts: SpareParts } =>
    group.driveGroup !== undefined && group.spareParts !== undefined;
